import { AfterViewInit, Component, ElementRef, inject } from '@angular/core';
import { CX_ABSTRACT_SECTION_COMPONENTS } from '@b2b/components/cms/cx-abstract/cx-abstract.tokens';
import { ScreenViewModule } from '@app/core/directives/screen-view/_screen-view.module';
import { CmsComponent } from '@app/core/models/atomics.model';
import { DEVICE_SIZE } from '@app/core/models/deviceSize.model';
import { HeaderDesktopComponent } from '@b2b/components/cms/sections/cx-header-section/components/header-desktop/header-desktop.component';
import { HeaderMobileComponent } from '@b2b/components/cms/sections/cx-header-section/components/header-mobile/header-mobile.component';

@Component({
  selector: 'cx-header-section',
  imports: [ScreenViewModule, HeaderDesktopComponent, HeaderMobileComponent],
  templateUrl: './cx-header-section.component.html',
})
export class CxHeaderSectionComponent implements AfterViewInit {
  protected DEVICE_SIZE = DEVICE_SIZE;
  protected components = inject<CmsComponent[]>(CX_ABSTRACT_SECTION_COMPONENTS);
  protected el = inject(ElementRef);

  ngAfterViewInit(): void {
    const parent = this.el.nativeElement.closest('[class$="__header-section"]');
    if (parent) {
      parent.classList.add('sticky-top');
    }
  }
}
